/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue } from '../../app.vues'
//
import SwbBidParity from './BidParity';
Vue.regist(SwbBidParity);
import SwbCallBidActRecList from './CallBidActRecList';
Vue.regist(SwbCallBidActRecList);

export function openBidParityDlg(callBidDocId, callback) {
    //
    Vue.$showDialog({
        title: '比价',
        width: '80%',
        height: '70%',
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-bid-parity :callBidDocId = "callBidDocId" @notity-syncRefresh = "syncRefreshBidParity($event)" ref="swb_bid_parity"></swb-bid-parity>' +
        '</div>',
        data: {
            callBidDocId: null
        },
        okClicked: function () {
            let self = this;
        },
        cancelClicked: function () {
            console.log("sdsada");
        },
        extClicked: function () {
            console.log("sdsada");
        },
        methods: {
            syncRefreshBidParity: function (isTrue) {
                console.log("进来啦");
                callback(isTrue);
            }
        },
        lifecycle: {
            created: function () {
                this.callBidDocId = callBidDocId;
            }
        },
    });
}

// 招标书操作记录
export function openCallBidActRecListDlg(docId,callback) {
    Vue.$showDialog({
        title: "招标书操作记录",
        width: 1000,
        height: 600,
        okVisible:false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-call-bid-act-rec :docId="docId"></swb-call-bid-act-rec>' +
        '</div>',
        data: {
            docId: docId
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/compo/callbid/selectDlg.js
// module id = 1188
// module chunks = 0